<template>
  <div class="title-div">
    <h1>Vue Component Test</h1>
    <navi></navi>
  </div>
</template>

<script>
import Navi from "./Navigation.vue";
export default {
  components: {
    Navi
  },
  methods: {}
}
</script>

<style scoped>
.title-div {
  background: rgb(196, 241, 112);
  border-bottom: 4px solid #05d3b7;
  box-sizing: border-box;
  padding: 20px;
  /* color: #fff; */
  font-size: 25px;
  height: 80px; 
}
</style>